var total_commission=0;
var total_gst=0;


function generateInvoice() {
    var tuitionFee = getParsedValue('#tuition_fee');
    var enrollmentFee = getParsedValue('#enrollment_fee');
    var materialFee = getParsedValue('#material_fee');
    var otherFee = getParsedValue('#other_fee');
    var bonusAmount = getParsedValue('#incentive');

    let subTotal = (tuitionFee - bonusAmount)

    let commissionAmount = getCommissionAmount();

    // let commission = subTotal * (40 / 100)
    // let gst = commission * 10 / 100;
    // let claimCommission = commission + gst;

    console.log("commissionAmount", commissionAmount);

    const isGstChecked = $("#gst_checker_tuition_fee").is(":checked")

    let gst = isGstChecked ? commissionAmount * 10 / 100 :  0 ;
    let claimCommission = commissionAmount + gst

    let payableToCollege = subTotal - claimCommission
    let unitPrice = tuitionFee - payableToCollege

    if ($('#agency_enrollment_fee').is(':checked')) {
        unitPrice += enrollmentFee
        console.log(unitPrice)
    } else if ($('#college_enrollment_fee').is(':checked')) {
        payableToCollege += enrollmentFee
        console.log(payableToCollege)
        // unit_price = parseFloat(tuition_fee - payable_to_college - enrollment_fee);
    }

    if ($('#agency_material_fee').is(':checked')) {
        unitPrice += materialFee;
        console.log(unitPrice)
    } else if ($('#college_material_fee').is(':checked')) {
        payableToCollege += materialFee;
        console.log(payableToCollege)
        // unit_price = parseFloat(tuition_fee - payable_to_college - material_fee);
    }

    if ($('#agency_other_fee').is(':checked')) {
        unitPrice += otherFee
        console.log(unitPrice)
    } else if ($('#college_other_fee').is(':checked')) {
        payableToCollege += otherFee;
        console.log(payableToCollege)
        // unit_price = parseFloat(tuition_fee - payable_to_college - other_fee);
    }

    $('#total_gst').val(gst.toFixed(2));
    $('#payable_to_college').val(payableToCollege.toFixed(2));

    let unit_price = parseFloat(unitPrice);
    $('#unit_price').val(unit_price.toFixed(2));

    $('#total_commission').val(commissionAmount);
    $('#final_total').val(claimCommission);
    $('#total_gst').val(gst);
    $('#tuition_fee_gst').val(gst);
    $('#sub_total').val(subTotal);

    console.log("claimCommission", claimCommission);
    console.log("payableToCollege", payableToCollege);
    console.log("unitPrice", unitPrice);
}
$(document).on("change","input[type='radio'][name='enrollment_fee']" ,function() {
    generateInvoice()
});

$(document).on("change","input[type='radio'][name='material_fee']" ,function() {
    generateInvoice()
});

$(document).on("change","input[type='radio'][name='other_fee']" ,function() {
    generateInvoice()
});

//
// if ($('#agency_other_fee').is(':checked')) {
//     unitPrice += otherFee
//     console.log(unitPrice)
// } else if ($('#college_other_fee').is(':checked')) {
//     payableToCollege += otherFee;
//     console.log(payableToCollege)
//     // unit_price = parseFloat(tuition_fee - payable_to_college - other_fee);
// }
$(document).on("click",'#gst_checker_tuition_fee', function() {
    if($(this).is(":checked")) {
        $('#total_gst').val( getParsedValue((commissionAmount * 10 / 100)));
    }
    else {
        $('#incentive_gst').val(0);
    }
});

$(document).on("click", "#generate-invoice", function(e) {
    e.preventDefault()
    console.log("CLicked");
    generateInvoice()
})

$(document).on("keyup", "#incentive", function () {
    generateInvoice()
})
$(document).on("keyup", "#tuition_fee", function () {
    console.log("dlksjflak")
    generateInvoice()
})

$(document).on("keyup", '#enrollment_fee', function() {
    generateInvoice();
});
$(document).on("keyup", '#material_fee', function() {
    generateInvoice();
});

$(document).on("keyup", '#other_fee', function() {
    generateInvoice();
});

$(document).on("keyup", '#sub_total', function() {
    generateInvoice();
});

$(document).on("change", "#gst_checker_tuition_fee", function () {
    generateInvoice()
})

$(document).on("change", "#commission_percent", function () {
    generateInvoice()
})

$(document).on("change", "#commission_amount", function () {
    generateInvoice()
})
// $('#gst_checker_tuition_fee').change(function() {
//     if(this.checked) {
//         var returnVal = confirm("Are you sure?");
//         $(this).prop("checked", returnVal);
//     }
// });

$(document).on("change",'#commission_type', function() {
    let commissionType = document.getElementById("commission_type").value;
    if (commissionType === "commission_amount") {
        document.getElementById("commission_amount_div").style.display = "block";
        document.getElementById("commission_percent_div").style.display = "none";
        document.getElementById("commission_amount").required = true;
        document.getElementById("commission_percent").required = false;
        document.getElementById("commission_percent").value = ""; // Reset commission percent value to null
    } else {
        document.getElementById("commission_percent_div").style.display = "block";
        document.getElementById("commission_amount_div").style.display = "none";
        document.getElementById("commission_amount").required = false;
        document.getElementById("commission_percent").required = true;
        document.getElementById("commission_amount").value = ""; // Reset commission amount value to null
    }
});


function getCommissionAmount() {
    let tuition_fee =    getParsedValue('#tuition_fee');
    let commissionAmount = 0.0;

    if (isNaN(tuition_fee)) {
        tuition_fee = 1;
    }

    let commissionType = '';
    let commissionTypeField = document.getElementById("commission_type");

    if(commissionTypeField) {
        commissionType = commissionTypeField.value;
    }

    if (commissionType === "commission_percent") {
        let other_amount =   getParsedValue('#incentive');
        let commissionPercent = getParsedValue('#commission_percent')
        commissionAmount = parseFloat(commissionPercent / 100 * (tuition_fee - other_amount));

    } else {
        commissionAmount = getParsedValue('#commission_amount')
    }

    return commissionAmount;
}
/*
    $(document).on("keyup",'.fee', function() {
        // $('#tuition_fee, #enrollment_fee, #material_fee, #coe_fee, #other_fee').keyup(function() {
        var tuitionFee =   getParsedValue('#tuition_fee');
        console.log("tuitionFee", tuitionFee);
        var enrollmentFee =  getParsedValue('#enrollment_fee');
        var materialFee =   getParsedValue('#material_fee');
        var coeFee =  getParsedValue('#coe_fee');
        var otherFee = getParsedValue('#other_fee');
        var other_amount =   getParsedValue('#incentive');
        var subTotal = parseFloat(tuitionFee - other_amount);
        $('#sub_total').val(subTotal);
        reset_value();
    });

    $(document).on("keyup",'.commission_fee', function() {
    // $('#commission_percent, #sub_total,#commission_amount,#incentive').keyup(function() {
        reset_value();
    });

    $(document).on("click",'#gst_checker_incentive', function() {
        if($(this).is(":checked")) {
            $('#incentive_gst').val( getParsedValue('#incentive') / 10);
        }
        else {
            $('#incentive_gst').val(0);
        }
        gst_change();
    });


    $(document).on("click",'#gst_checker_tuition_fee', function() {
        if($(this).is(":checked")) {
            let commissionAmount = getCommissionAmount();
            console.log('commissionAmount = ', commissionAmount);
            $('#tuition_fee_gst').val(  commissionAmount  / 10 );
        }
        else {
            $('#tuition_fee_gst').val(0);
        }
        gst_change();
    });


    function getCommissionAmount() {
        let tuition_fee =    getParsedValue('#tuition_fee');
        let commissionAmount = 0.0;

        if (isNaN(tuition_fee)) {
            tuition_fee = 1;
        }

        let commissionType = '';
        let commissionTypeField = document.getElementById("commission_type");

        if(commissionTypeField) {
            commissionType = commissionTypeField.value;
        }

        if (commissionType === "commission_percent") {
            let other_amount =   getParsedValue('#incentive');
            let commissionPercent = getParsedValue('#commission_percent')
            commissionAmount = parseFloat(commissionPercent / 100 * (tuition_fee - other_amount));

        } else {
            commissionAmount = getParsedValue('#commission_amount')
        }

        return commissionAmount;
    }

    $(document).on("change",'#commission_type', function() {
        let commissionType = document.getElementById("commission_type").value;
        if (commissionType === "commission_amount") {
            document.getElementById("commission_amount_div").style.display = "block";
            document.getElementById("commission_percent_div").style.display = "none";
            document.getElementById("commission_amount").required = true;
            document.getElementById("commission_percent").required = false;
            document.getElementById("commission_percent").value = ""; // Reset commission percent value to null
        } else {
            document.getElementById("commission_percent_div").style.display = "block";
            document.getElementById("commission_amount_div").style.display = "none";
            document.getElementById("commission_amount").required = false;
            document.getElementById("commission_percent").required = true;
            document.getElementById("commission_amount").value = ""; // Reset commission amount value to null
        }
    });

    //----------------------------------
    // function gst_change(){
    //     let commissionAmount = getCommissionAmount();
    //     var tuition_fee =   getParsedValue('#tuition_fee');
    //     let tuition_fee_gst=   getParsedValue('#tuition_fee_gst');
    //     let incentive = getParsedValue('#incentive');
    //     let incentive_gst = getParsedValue('#incentive_gst');
    //
    //     total_commission= commissionAmount;
    //     total_gst= tuition_fee_gst + incentive_gst;
    //     final_total= total_commission + total_gst;
    //     payable_to_college=$('#sub_total').val()-final_total;
    //     $('#total_commission').val(total_commission.toFixed(2));
    //     $('#total_gst').val(total_gst.toFixed(2));
    //     $('#final_total').val(final_total.toFixed(2));
    //     $('#payable_to_college').val(payable_to_college.toFixed(2));
    //
    //     let unit_price = parseFloat(tuition_fee - payable_to_college);
    //     $('#unit_price').val(unit_price.toFixed(2));
    // }
    //-----------------------------------

    $(document).on("change", 'input[name="enrollment_fee"]', function() {
        gst_change();
    });
    $(document).on("change", 'input[name="material_fee"]', function() {
        gst_change();
    });

    $(document).on("change", 'input[name="other_fee"]', function() {
        gst_change();
    });

    function gst_change() {
        let commissionAmount = getCommissionAmount();
        let tuition_fee = getParsedValue('#tuition_fee');
        let tuition_fee_gst = getParsedValue('#tuition_fee_gst');
        let incentive = getParsedValue('#incentive');
        let incentive_gst = getParsedValue('#incentive_gst');
        let enrollment_fee = getParsedValue('#enrollment_fee');
        let material_fee = getParsedValue('#material_fee');
        let other_fee = getParsedValue('#other_fee');
        let total_commission = commissionAmount;
        let total_gst = tuition_fee_gst + incentive_gst;
        let final_total = total_commission + total_gst;
        let payable_to_college = $('#sub_total').val() - final_total;
        let unit_price = parseFloat(tuition_fee - payable_to_college);
        console.log(unit_price)

        if ($('#agency_enrollment_fee').is(':checked')) {
            unit_price += enrollment_fee
            console.log(unit_price)
        } else if ($('#college_enrollment_fee').is(':checked')) {
            payable_to_college += enrollment_fee
            console.log(payable_to_college)
            // unit_price = parseFloat(tuition_fee - payable_to_college - enrollment_fee);
        }

        if ($('#agency_material_fee').is(':checked')) {
            unit_price += material_fee;
            console.log(unit_price)
        } else if ($('#college_material_fee').is(':checked')) {
            payable_to_college += material_fee;
            console.log(payable_to_college)
            // unit_price = parseFloat(tuition_fee - payable_to_college - material_fee);
        }

        if ($('#agency_other_fee').is(':checked')) {
            unit_price += other_fee
            console.log(unit_price)
        } else if ($('#college_other_fee').is(':checked')) {
            payable_to_college += other_fee;
            console.log(payable_to_college)
            // unit_price = parseFloat(tuition_fee - payable_to_college - other_fee);
        }

        $('#total_commission').val(total_commission.toFixed(2));
        $('#total_gst').val(total_gst.toFixed(2));
        $('#final_total').val(final_total.toFixed(2));
        $('#payable_to_college').val(payable_to_college.toFixed(2));
        $('#unit_price').val(unit_price.toFixed(2));
    }
    function reset_value(){
        console.log('call reset');
        var commissionPercent = 0;
        var tuition_fee =   getParsedValue('#tuition_fee');
        var other_amount =   getParsedValue('#incentive');
        var commissionAmount = 0.0;

        let commissionType = document.getElementById("commission_type");

        if (commissionType) {
            if (commissionType.value === "commission_percent") {
                // let other_amount =   getParsedValue('#incentive');
                commissionPercent = getParsedValue('#commission_percent')
                commissionAmount = parseFloat(commissionPercent / 100 * (tuition_fee - other_amount));

            } else {
                commissionAmount = getParsedValue('#commission_amount')
            }
        }


        // $('#commission_amount').val(commissionAmount.toFixed(2));

        if($('#gst_checker_tuition_fee').is(":checked")) // "this" refers to the element that fired the event
        {
            var tuition_fee_gst= commissionAmount / 10;
        }
        else {
            tuition_fee_gst=0;
        }
        $('#tuition_fee_gst').val(tuition_fee_gst.toFixed(2));

        var incentive = getParsedValue('#incentive');

        if($('#gst_checker_incentive').is(":checked")) {
            var incentive_gst = incentive /10;
        }
        else {
            var incentive_gst=0;
        }
        $('#incentive_gst').val(incentive_gst.toFixed(2));

        total_commission= commissionAmount;
        total_gst= tuition_fee_gst + incentive_gst;
        final_total= total_commission + total_gst;
        payable_to_college=$('#sub_total').val() - final_total;
        $('#total_commission').val( total_commission.toFixed(2) );
        $('#total_gst').val( total_gst.toFixed(2));
        $('#final_total').val( final_total.toFixed(2));
        $('#payable_to_college').val( payable_to_college.toFixed(2));

        let unit_price = parseFloat(tuition_fee - payable_to_college);
        $('#unit_price').val(unit_price.toFixed(2));
    }

    function getParsedValue(element) {
        return parseFloat($(element).val() || 0)
    }

    gst_change();
    */

function getParsedValue(element) {
    return parseFloat($(element).val() || 0)
}